import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMessageCircle } = FiIcons;

const CallToAction = () => {
  const phoneNumber = "251-522-9131";

  return (
    <section className="py-20 bg-red-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute -right-20 -top-20 w-96 h-96 bg-black rounded-full mix-blend-multiply filter blur-3xl"></div>
        <div className="absolute -left-20 -bottom-20 w-96 h-96 bg-black rounded-full mix-blend-multiply filter blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Get Your Cash Offer from Tyler Today
          </h2>
          <p className="text-xl text-red-100 mb-8 leading-relaxed">
            Don't let your property sit on the market for months. I'm a direct buyer, not an agent, and I'm ready to make you a fair offer right now.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
            <motion.a
              href={`tel:${phoneNumber}`}
              className="flex items-center space-x-3 bg-white text-red-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-100 transition-colors shadow-lg w-full sm:w-auto"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiPhone} className="w-6 h-6" />
              <span>Call Tyler: {phoneNumber}</span>
            </motion.a>

            <motion.a
              href={`sms:${phoneNumber}`}
              className="flex items-center space-x-3 bg-black text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-900 transition-colors shadow-lg w-full sm:w-auto"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiMessageCircle} className="w-6 h-6" />
              <span>Text Tyler Now</span>
            </motion.a>
          </div>

          <div className="text-red-100 text-sm italic">
            <p>"I personally review every property and guarantee a fair, transparent offer." — Tyler</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CallToAction;